import { z } from 'zod'
import { dataNominal, uuid } from './comum.js'
import { dinheiroPositivo } from './contas-pagar.js'

export const entradaDeAtivoIntangivel = z.object({
  nome: z.string().trim().min(1).max(200),
  itemContabilId: uuid,
  valorCapitalizado: dinheiroPositivo,
  ativacao: dataNominal,
  prazoMeses: z.number().int().positive().max(32767),
})
export type EntradaDeAtivoIntangivel = z.infer<typeof entradaDeAtivoIntangivel>

export const parcelaDeAmortizacao = z.object({
  id: uuid,
  competencia: dataNominal,
  valor: z.string(),
  lancada: z.boolean(),
})
export type ParcelaDeAmortizacao = z.infer<typeof parcelaDeAmortizacao>

export const ativoIntangivel = z.object({
  id: uuid,
  entityId: uuid,
  nome: z.string(),
  itemContabilId: uuid.nullable(),
  itemContabilNome: z.string().nullable(),
  valorCapitalizado: z.string(),
  ativacao: dataNominal,
  prazoMeses: z.number().int().positive(),
  taxaAa: z.string(),
  situacaoAgenda: z.enum(['nao_gerada', 'incompleta', 'completa']),
  totalAgenda: z.string(),
  quantidadeAgenda: z.number().int().nonnegative(),
  agenda: z.array(parcelaDeAmortizacao),
})
export type AtivoIntangivel = z.infer<typeof ativoIntangivel>

export interface RespostaDeAtivosIntangiveis {
  readonly data: AtivoIntangivel[]
  readonly meta: {
    readonly itensContabeis: readonly { id: string; nome: string }[]
    readonly podeCriar: boolean
    readonly podeEditar: boolean
  }
}
